export class DataTopUp {
    bundle: string;
    dataPackage: string;
    cardNumber: string;
    emailAddress: string;
    cvv: string;

    constructor() {
        this.bundle = "";
        this.dataPackage = "";
        this.cardNumber = "";
        this.emailAddress = "";
        this.cvv = "";
    }
}